<template>
  <div class="sectionx">
    <br />
    <form>
      <div class="row">
        <div class="col s12 m4">
          <!-- <div class="card-panel"> -->
          <FilterDiv inputId="filterScheme" :data="filterSchemeData" :startAgain="resetScheme" @selected="handlePick"
            @searching="handleSearch" @clear="handleClear" />
          <!-- </div> -->
        </div>

        <div class="col s12 m4">
          <!-- <div class="card-panel"> -->
          <FilterDiv inputId="filterDuration" :data="filterDurationData" :startAgain="resetDuration"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <!-- </div> -->
        </div>

        <div class="col s12 m4">
          <!-- <div class="card-panel"> -->
          <FilterDiv v-if="!isCompactScreen" inputId="filterProvider" :data="filterProviderData" :startAgain="resetProvider"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <MobileRemoteSearchSheet v-else inputId="filterProvider" label="Provider" :data="filterProviderData" :startAgain="resetProvider"
            :resetSignal="resetProviderSignal"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <!-- </div> -->
        </div>

        <div class="col s12 m6">
          <!-- <div class="card-panel"> -->
          <FilterDiv v-if="!isCompactScreen" inputId="filterClient" :data="filterClientData" :startAgain="resetClient"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <MobileRemoteSearchSheet v-else inputId="filterClient" label="Client" :data="filterClientData" :startAgain="resetClient"
            :resetSignal="resetClientSignal"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <!-- </div> -->
        </div>

        <div class="col s12 m6">
          <!-- <div class="card-panel"> -->
          <FilterDiv v-if="!isCompactScreen" inputId="filterEnrollee" :data="filterEnrolleeData" :startAgain="resetEnrollee"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <MobileRemoteSearchSheet v-else inputId="filterEnrollee" label="Enrollee" :data="filterEnrolleeData" :startAgain="resetEnrollee"
            :resetSignal="resetEnrolleeSignal"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <!-- </div> -->
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onBeforeUnmount, onMounted, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import getItems from "@/composables/getItems";
import FilterDiv from "@/components/search/FilterDiv.vue";
import MobileRemoteSearchSheet from "@/components/search/MobileRemoteSearchSheet.vue";
import { searchMonths } from "@/composables/fxLibrary/months";

export default {
  name: "FilterEnrolleeComponent",
  components: { FilterDiv, MobileRemoteSearchSheet },
  emits: ["search"],
  setup(props, context) {
    const responseSearch = ref(null);
    const responseSchemeDefault = ref(null);
    const responseDurationDefault = ref(null);
    const resetEnrollee = ref(null);
    const resetClient = ref(null);
    const resetScheme = ref(null);
    const resetDuration = ref(null);
    const resetProvider = ref(null);
    const resetEnrolleeSignal = ref(0);
    const resetClientSignal = ref(0);
    const resetProviderSignal = ref(0);
    const searchBody = ref([]);
    const selectedItem = ref(null);
    const selectedEnrollee = ref("");
    const selectedProvider = ref("");
    const selectedClient = ref("");
    const selectedScheme = ref("");
    const selectedDuration = ref("");
    const specialCase = ref([]);
    const isCompactScreen = ref(false);
    let compactMediaQuery = null;

    // store
    const store = useStore();

    const resetFilter = (resetRef, value, signalRef = null) => {
      resetRef.value = value;
      if (signalRef) {
        signalRef.value += 1;
      }
    };

    const updateCompactScreen = (event) => {
      isCompactScreen.value = event.matches;
    };

    onMounted(() => {
      compactMediaQuery = window.matchMedia("(max-width: 992px)");
      isCompactScreen.value = compactMediaQuery.matches;

      if (compactMediaQuery.addEventListener) {
        compactMediaQuery.addEventListener("change", updateCompactScreen);
      } else {
        compactMediaQuery.addListener(updateCompactScreen);
      }
    });

    onBeforeUnmount(() => {
      if (!compactMediaQuery) {
        return;
      }

      if (compactMediaQuery.removeEventListener) {
        compactMediaQuery.removeEventListener("change", updateCompactScreen);
      } else {
        compactMediaQuery.removeListener(updateCompactScreen);
      }
    });

    // enrollee data
    const filterEnrolleeData = computed(() => {
      // start
      let val = {
        "All Enrollees": null,
      };

      let valPlus;
      let valPlusPlus;

      if (responseSearch.value) {
        if (responseSearch.value.key == "filterEnrollee") {
          valPlus = responseSearch.value.value.reduce((newArr, x) => {
            newArr[x.name] = null;
            return newArr;
          }, {});
          valPlusPlus = responseSearch.value.value.reduce((newArr, x) => {
            newArr[x.enrollee_number] = null;
            return newArr;
          }, {});
          val = { ...val, ...valPlus, ...valPlusPlus };
        }
      }

      // return final
      return val;
    });

    // provider data
    const filterProviderData = computed(() => {
      // start
      let val = {
        "All Providers": null,
      };

      let valPlus;

      if (responseSearch.value) {
        if (responseSearch.value.key == "filterProvider") {
          valPlus = responseSearch.value.value.reduce((newArr, x) => {
            newArr[x.picked_provider] = null;
            return newArr;
          }, {});
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // scheme data
    const filterSchemeData = computed(() => {
      // start
      let val = {}; // load on fly

      let valPlus;

      if (responseSchemeDefault.value) {
        if (responseSchemeDefault.value.key == "filterScheme") {
          valPlus = responseSchemeDefault.value.value.reduce((newArr, x) => {
            newArr[x.name] = null;
            return newArr;
          }, {});
          val = { ...valPlus }; // ignore val (its null)
        }
      }

      // return final
      return val;
    });

    // Duration
    const filterDurationData = computed(() => {
      // start
      let val = {}; // load on fly

      let valPlus;

      if (responseDurationDefault.value) {
        if (responseDurationDefault.value.key == "filterDuration") {
          valPlus = responseDurationDefault.value.value.reduce((newArr, x) => {
            newArr[x.period] = null;
            return newArr;
          }, {});
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // duration data
    const filterClientData = computed(() => {
      // start
      let val = {
        "All Clients": null,
      };

      let valPlus;

      if (responseSearch.value) {
        if (responseSearch.value.key == "filterClient") {
          valPlus = responseSearch.value.value.reduce((newArr, x) => {
            newArr[x.client_name] = null;
            return newArr;
          }, {});
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // search function
    const getSearchItemsFromApi = (table, key) => {
      (async () => {
        const { res } = await getItems(table);
        if (res.value) {
          // search
          responseSearch.value = { key: key, value: res.value.data };
        }
      })();
    };

    // scheme initialization
    onMounted(() => {

      /* 
    Initiate Here
    */
      let allowedSchemes = [];
      let currScheme = null;
      if (store.state?.user.schemes) {
        allowedSchemes = store.state.user.schemes; // all user schemes
        currScheme = store.state.user.schemes.find(x => x.curr); // first curr is true
      }

      /* 
      One Type
      */
      responseSchemeDefault.value = {
        key: "filterScheme",
        value: allowedSchemes,
      };

      /*
      Special defualt cases
      */
      specialCase.value.push({
        ...currScheme,
        key: "filterScheme",
      });

      // current scheme
      /* Set reset (search special array, 
      in case there are other special cases)
      */
      specialCase.value.forEach((x) => {
        if (x.key == "filterScheme") {
          // filter display
          resetScheme.value = x.name;
          // trigger search
          selectedItem.value = { id: x.key, value: x.name, special: true };
        }
      });
    });

    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      const { fx } = searchMonths(true); // true for next month

      /*
     Special defualt cases
     */
      specialCase.value.push({ ...fx.value[1], key: "filterDuration" }); // current month

      // set
      responseDurationDefault.value = {
        key: "filterDuration",
        value: fx.value,
      };

      /*
     Set reset (search special array, 
     in case there are other special cases)
     */
      specialCase.value.forEach((x) => {
        if (x.key == "filterDuration") {
          // filter display
          resetDuration.value = x.period;
          // search results
          searchBody.value.push(`Period (${x.period})`);
          // search params
          selectedDuration.value = x.date; // load directly
        }
      });
    });

    // enrollee, provider & client filter
    const handleSearch = (val) => {
      if (val.id == "filterEnrollee") {
        // get new serach items
        getSearchItemsFromApi(`enrollee/filter?q=${val.value}`, val.id);
      } else if (val.id == "filterProvider") {
        // get new serach items
        getSearchItemsFromApi(
          `enrollee/filter/provider?q=${val.value}`,
          val.id
        );
      } else if (val.id == "filterScheme") {
        // preset onMounted
      } else if (val.id == "filterClient") {
        // get new serach items
        getSearchItemsFromApi(`enrollee/filter/client?q=${val.value}`, val.id);
      } else if (val.id == "filterDuration") {
        // preset
      }
    };

    // clear (null reset)
    const handleClear = (val) => {
      if (val.id == "filterEnrollee") {
        resetEnrollee.value = val.value;
      } else if (val.id == "filterProvider") {
        resetProvider.value = val.value;
      } else if (val.id == "filterScheme") {
        resetScheme.value = val.value;
      } else if (val.id == "filterClient") {
        resetClient.value = val.value;
      } else if (val.id == "filterDuration") {
        resetDuration.value = val.value;
      }
    };

    // selected item
    const handlePick = (val) => {
      selectedItem.value = val;
      // watchEffect will take over from here
    };

    // route composer
    watchEffect(() => {
      // token
      let searchToken = false;

      // start
      if (selectedItem.value) {
        // sort
        if (selectedItem.value.id == "filterEnrollee") {
          // set token
          searchToken = true;

          //set
          if (
            Object.keys(filterEnrolleeData.value)[0] == selectedItem.value.value
          ) {
            selectedEnrollee.value = "";
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Enrollee")
            );
          } else {
            // update search body
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Enrollee")
            );
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Provider") && !x.includes("Client")
            );
            searchBody.value.push(`Enrollee (${selectedItem.value.value})`);
            // get enrollee number from name or enrollee_number (self)
            // responseSearch will have all the complete data
            responseSearch.value.value.forEach((x) => {
              if (x.name == selectedItem.value.value) {
                // found
                selectedEnrollee.value = x.enrollee_number;
              }
              if (x.enrollee_number == selectedItem.value.value) {
                // found
                selectedEnrollee.value = x.enrollee_number;
              }
            });
            if (selectedEnrollee.value) {
              // reset search fields (for better search results)
              resetFilter(resetProvider, Object.keys(filterProviderData.value)[0], resetProviderSignal);
              resetFilter(resetClient, Object.keys(filterClientData.value)[0], resetClientSignal);
              // clear corresponding search
              selectedProvider.value = "";
              selectedClient.value = "";
            }
          }
        } else if (selectedItem.value.id == "filterProvider") {
          // set token
          searchToken = true;

          //set
          if (
            Object.keys(filterProviderData.value)[0] == selectedItem.value.value
          ) {
            selectedProvider.value = "";
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Provider")
            );
          } else {
            // update search body
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Provider")
            );
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Enrollee") && !x.includes("Client")
            );
            searchBody.value.push(`Provider (${selectedItem.value.value})`);
            // get provider id
            // responseSearch will have all the complete data
            responseSearch.value.value.forEach((x) => {
              if (x.picked_provider == selectedItem.value.value) {
                // found
                selectedProvider.value = x.picked_provider;
              }
            });
            if (selectedProvider.value) {
              // reset search fields (for better search results)
              resetFilter(resetEnrollee, Object.keys(filterEnrolleeData.value)[0], resetEnrolleeSignal);
              resetFilter(resetClient, Object.keys(filterClientData.value)[0], resetClientSignal);
              // clear corresponding search
              selectedEnrollee.value = "";
              selectedClient.value = "";
            }
          }
        } else if (selectedItem.value.id == "filterClient") {
          // set token
          searchToken = true;

          //set
          if (
            Object.keys(filterClientData.value)[0] == selectedItem.value.value
          ) {
            selectedClient.value = "";
            searchBody.value = searchBody.value.filter((x) => !x.includes("Client"));
          } else {
            // update search body
            searchBody.value = searchBody.value.filter((x) => !x.includes("Client"));
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Enrollee") && !x.includes("Provider")
            );
            searchBody.value.push(`Client (${selectedItem.value.value})`);
            // get client
            // responseSearch will have all the complete data
            responseSearch.value.value.forEach((x) => {
              if (x.client_name == selectedItem.value.value) {
                // found
                selectedClient.value = x.client_name;
              }
            });
            if (selectedClient.value) {
              // reset search fields (for better search results)
              resetFilter(resetEnrollee, Object.keys(filterEnrolleeData.value)[0], resetEnrolleeSignal);
              resetFilter(resetProvider, Object.keys(filterProviderData.value)[0], resetProviderSignal);
              // clear corresponding search
              selectedEnrollee.value = "";
              selectedProvider.value = "";
            }
          }
        } else if (selectedItem.value.id == "filterDuration") {
          // set token
          searchToken = true;
          // check default
          if (selectedItem.value.special) {
            specialCase.value.forEach((x) => {
              if (x.key == "filterDuration") {
                resetDuration.value = x.period;
                selectedItem.value.value = x.period;
              }
            });
          }

          // update search body
          searchBody.value = searchBody.value.filter(
            (x) => !x.includes("Period")
          );
          searchBody.value = searchBody.value.filter(
            (x) => !x.includes("Enrollee") && !x.includes("Client") && !x.includes("Provider")
          );
          searchBody.value.push(`Period (${selectedItem.value.value})`);

          // get duration day
          // responseDurationDefault will have all the complete data
          responseDurationDefault.value.value.forEach((x) => {
            if (x.period == selectedItem.value.value) {
              // found
              selectedDuration.value = x.date;
            }
          });
          if (selectedDuration.value) {
            // reset search fields (for better search results)
            resetFilter(resetEnrollee, Object.keys(filterEnrolleeData.value)[0], resetEnrolleeSignal);
            resetFilter(resetProvider, Object.keys(filterProviderData.value)[0], resetProviderSignal);
            resetFilter(resetClient, Object.keys(filterClientData.value)[0], resetClientSignal);
            // clear corresponding search
            selectedEnrollee.value = "";
            selectedProvider.value = "";
            selectedClient.value = "";
          }

        } else if (selectedItem.value.id == "filterScheme") {
          // set token
          searchToken = true;
          // check default
          if (selectedItem.value.special) {
            specialCase.value.forEach((x) => {
              if (x.key == "filterScheme") {
                resetScheme.value = x.name;
                selectedItem.value.value = x.name;
              }
            });
          }

          //set (no empty scheme)
          // update search body
          searchBody.value = searchBody.value.filter(
            (x) => !x.includes("Scheme")
          );
          searchBody.value = searchBody.value.filter(
            (x) => !x.includes("Enrollee") && !x.includes("Client") && !x.includes("Provider")
          );
          searchBody.value.unshift(`Scheme (${selectedItem.value.value})`); // always first
          // get scheme id
          // responseSchemeDefault will have all the complete data
          responseSchemeDefault.value.value.forEach((x) => {
            if (x.name == selectedItem.value.value) {
              // found
              selectedScheme.value = x.id;
            }
          });
          if (selectedScheme.value) {
            // reset search fields (for better search results)
            resetFilter(resetEnrollee, Object.keys(filterEnrolleeData.value)[0], resetEnrolleeSignal);
            resetFilter(resetProvider, Object.keys(filterProviderData.value)[0], resetProviderSignal);
            resetFilter(resetClient, Object.keys(filterClientData.value)[0], resetClientSignal);
            // clear corresponding search
            selectedEnrollee.value = "";
            selectedProvider.value = "";
            selectedClient.value = "";
          }
        }

        if (searchToken) {
          // start laoding
          let searchTitle = null;
          let currUrl = null;
          let currHook = null;

          // label
          if (
            selectedEnrollee.value ||
            selectedProvider.value ||
            selectedScheme.value ||
            selectedClient.value ||
            selectedDuration.value
          ) {
            let uniqueBody = [...new Set(searchBody.value)];
            searchTitle = `<span class="black blue-text chip">Search <i class="tiny material-icons">check_circle</i></span>`;
            uniqueBody.forEach((x) => {
              searchTitle += `<span class="yellow lighten-2 black-text chip"><em>${x}</em></span> `;
            });
            searchTitle = searchTitle.slice(0, -2);
          } else {
            searchTitle = null;
          }


          /* 
          Check url (accessController)
          Update Curr Scheme from User
          */
          let accessController = null;
          if (store.state?.user.schemes) {

            // scheme allowed
            accessController = store.state.user.schemes.find(x => x.id === selectedScheme.value);

            // if found
            // update curr scheme
            if (accessController) {
              let user = store.state.user;
              user.schemes.forEach((x) => {
                if (x.id == selectedScheme.value) {
                  x.curr = true;
                } else {
                  x.curr = false;
                }
              })

              // make sure there is still at least a curr
              if (user.schemes.find(x => x.curr)) {
                store.commit("loadUser", user);
              }
            }
          }


          if (accessController) {

            // set current Url
            currUrl = `enrollee/list/search?e=${selectedEnrollee.value}&p=${selectedProvider.value}&s=${selectedScheme.value}&c=${selectedClient.value}&d=${selectedDuration.value}`;
            // set current Hook
            currHook = "&";

            // emit new parameters
            context.emit("search", {
              searchTitle: searchTitle,
              listMonth: selectedDuration.value,
              currUrl: currUrl,
              currHook: currHook,
            });

          }

          // kill token
          searchToken = false;
          // kill searchItem
          selectedItem.value = null;
        }
      }
    });

    return {
      handleSearch,
      handleClear,
      handlePick,
      selectedItem,
      resetEnrollee,
      resetClient,
      resetScheme,
      resetDuration,
      resetProvider,
      resetEnrolleeSignal,
      resetClientSignal,
      resetProviderSignal,
      filterEnrolleeData,
      filterProviderData,
      filterSchemeData,
      filterDurationData,
      filterClientData,
      selectedEnrollee,
      selectedProvider,
      selectedScheme,
      selectedDuration,
      selectedClient,
      isCompactScreen,
    };
  },
};
</script>

<style></style>
